import { httpClient } from './httpClient';

const base = '/api/personas';

export const crearPersona = (payload) => httpClient.post(base, payload);

export const resumenPersonas = () => httpClient.get(`${base}/resumen`);

export const listarPersonas = ({ busqueda, tipo_doc, limit, offset } = {}) => {
  const p = new URLSearchParams();
  if (busqueda)  p.append('busqueda', busqueda);
  if (tipo_doc)  p.append('tipo_doc', tipo_doc);
  if (limit)     p.append('limit', limit);
  if (offset)    p.append('offset', offset);
  const qs = p.toString();
  return httpClient.get(`${base}${qs ? `?${qs}` : ''}`);
};

export const obtenerPersona = (id) => httpClient.get(`${base}/${id}`);

export const actualizarPersona = (id, payload) => httpClient.patch(`${base}/${id}`, payload);

export const listarPagosPersona = (id) => httpClient.get(`${base}/${id}/pagos`);

export const sincronizarPersonaContifico = (id) => httpClient.post(`${base}/${id}/sincronizar-contifico`, {});
